import { createTrackerForCategory } from '@gonfalon/analytics/createTrackerForCategory';
import type { AnalyticEventData } from '@gonfalon/analytics/types';

type TrackEnvironmentColorEventAttributes = {
  color: string;
  type: string;
};

export const trackEnvironmentEvent = (
  event: string,
  attributes?: TrackEnvironmentColorEventAttributes | AnalyticEventData,
) => {
  createTrackerForCategory('Environment')(event, attributes);
};
